import { render, staticRenderFns } from "./mould_equipment_index.vue?vue&type=template&id=8802aa68&"
import script from "./mould_equipment_index.vue?vue&type=script&lang=js&"
export * from "./mould_equipment_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports